const components = {
    "market_integrations": {
        "appsumo_register": () => import('./../pages/markets/appsumo/index'),
        "appsumo_activation": () => import('./../pages/markets/appsumo/ActivationByEmail'),
    },

    "market_integration_settings": {
        "webhooks": () => import('./../pages/admin/webhooks/index'),
        "appsumo_verify_license": () => import('./../pages/admin/verify-appsumo/index'),
    }
};

export default components;
